// components/SellerInfo.js
import React, { useEffect, useState } from 'react';
import { TextField, Checkbox, FormControlLabel } from '@mui/material';
// import styled from 'styled-components';

import { Label, BaseLabel, RowContainer, Select, AutoCompleteSmall, InputSmall, cores } from '../../../styles/styleUtils';

import { getUsuarios } from '../../api';

import { useUnidades, isSameUnidade } from '../../../hooks/useUnidades';

function SellerInfo({ formData, onInputChange, onAutoCompleteChange, disabled }) {
  const [options, setOptions] = useState([]);
  const { unidades } = useUnidades();

  useEffect(() => {
    fetchOptions();
  }, []);

  const fetchOptions = async () => {
    const result = await getUsuarios();
    setOptions(result);
  };
  const attendanceTypes = ['Prospecção', 'Agendamento', 'Lead', 'Indicação'];

  // Comissão: dois percentuais independentes (cada um % do valor total da venda).
  // Os valores em R$ são derivados (somente leitura).
  const totalVenda = Number(formData.valor) || 0;
  const fmtMoeda = (v) => (v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  const valorComissaoAbertura = (totalVenda * (Number(formData.comissaoPercentAbertura) || 0)) / 100;
  const valorComissaoFechamento = (totalVenda * (Number(formData.comissaoPercentFechamento) || 0)) / 100;

  // Abertura = Fechamento → não há divisão: o campo de comissão de fechamento fica bloqueado.
  const mesmoVendedor =
    !!formData.vendedorAbertura &&
    !!formData.vendedorFechamento &&
    (formData.vendedorAbertura._id
      ? formData.vendedorAbertura._id === formData.vendedorFechamento._id
      : formData.vendedorAbertura.nome === formData.vendedorFechamento.nome);

  return (
    <div>
      <RowContainer>
        <BaseLabel htmlFor="vendedorAbertura">Vendedor Abertura</BaseLabel>
        <AutoCompleteSmall
          disablePortal
          id="vendedorAbertura"
          name="vendedorAbertura"
          value={formData.vendedorAbertura || null}
          onChange={(_, value) => onAutoCompleteChange('idVendedorAbertura','vendedorAbertura', value)}
          options={options}
          isOptionEqualToValue={(option, value) => option._id === value._id}
          getOptionLabel={(option) => `${option.nome}`}
          renderInput={(params) => <TextField {...params} placeholder="Selecione" />}
        />

        <span />
        <span />
        <span />
        <Label htmlFor="vendedorFechamento">Vendedor Fechamento</Label>
        <AutoCompleteSmall
          disablePortal
          id="vendedorFechamento"
          name="vendedorFechamento"
          value={formData.vendedorFechamento || null}
          onChange={(_, value) => onAutoCompleteChange('idVendedorFechamento','vendedorFechamento', value)}
          options={options}
          isOptionEqualToValue={(option, value) => option._id === value._id}
          getOptionLabel={(option) => `${option.nome}`}
          renderInput={(params) => <TextField {...params} placeholder="Selecione" />}
        />
      </RowContainer>

      <RowContainer>
        <BaseLabel htmlFor="unidade">Unidade</BaseLabel>
        <AutoCompleteSmall
          disablePortal
          id="unidade"
          value={formData.unidade || null}
          options={unidades}
          isOptionEqualToValue={isSameUnidade}
          getOptionLabel={(option) => `${option.nome}`}
          renderInput={(params) => <TextField {...params} placeholder="Selecione" />}
          onChange={(_, value) => onAutoCompleteChange(null,'unidade', value)}
          disabled={disabled}
        />
        <span />
        <span />
        <span />
        <Label htmlFor="formaAtendimento">Forma de Atendimento</Label>
        <Select
          id="formaAtendimento"
          name="formaAtendimento"
          value={formData.formaAtendimento}
          onChange={onInputChange}
        >
          <option value="">Selecione</option>
          {attendanceTypes.map((type) => (
            <option key={type} value={type}>
              {type}
            </option>
          ))}
        </Select>
      </RowContainer>

      <RowContainer>
        <FormControlLabel
          sx={{ color: 'white' }}
          control={(
            <Checkbox
              id="comissaoNaoAplicavel"
              name="comissaoNaoAplicavel"
              checked={!!formData.comissaoNaoAplicavel}
              onChange={onInputChange}
              disabled={disabled}
              sx={{
                color: 'rgba(255,255,255,0.7)',
                '&.Mui-checked': { color: cores.laranja },
              }}
            />
          )}
          label="Comissão não aplicável (abertura e fechamento)"
        />
      </RowContainer>

      {!formData.comissaoNaoAplicavel && (
        <>
          <RowContainer>
            <BaseLabel htmlFor="comissaoPercentAbertura">Comissão Abertura (%)</BaseLabel>
            <InputSmall
              type="number"
              id="comissaoPercentAbertura"
              name="comissaoPercentAbertura"
              value={formData.comissaoPercentAbertura ?? ''}
              onChange={onInputChange}
              disabled={disabled}
              min="0"
              step="0.01"
            />
            <span />
            <span />
            <span />
            <Label htmlFor="valorComissaoAbertura">Valor (Abertura)</Label>
            <InputSmall type="text" id="valorComissaoAbertura" value={fmtMoeda(valorComissaoAbertura)} disabled readOnly />
          </RowContainer>

          <RowContainer>
            <BaseLabel htmlFor="comissaoPercentFechamento">Comissão Fechamento (%)</BaseLabel>
            <InputSmall
              type="number"
              id="comissaoPercentFechamento"
              name="comissaoPercentFechamento"
              value={mesmoVendedor ? '' : formData.comissaoPercentFechamento ?? ''}
              onChange={onInputChange}
              disabled={disabled || mesmoVendedor}
              min="0"
              step="0.01"
            />
            <span />
            <span />
            <span />
            <Label htmlFor="valorComissaoFechamento">Valor (Fechamento)</Label>
            <InputSmall
              type="text"
              id="valorComissaoFechamento"
              value={fmtMoeda(mesmoVendedor ? 0 : valorComissaoFechamento)}
              disabled
              readOnly
            />
          </RowContainer>
        </>
      )}
    </div>
  );
}

export default SellerInfo;